import { render, staticRenderFns } from "./NewCustomField.vue?vue&type=template&id=8cd0130a&"
import script from "./NewCustomField.vue?vue&type=script&lang=ts&"
export * from "./NewCustomField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports